import React, { useState, useEffect } from 'react';
import {BsChevronLeft, BsChevronRight} from "react-icons/bs";
import {CgArrowsExchangeV} from 'react-icons/cg';
import {GrClose, GrDeliver} from 'react-icons/gr';
import moment from "moment-timezone";
import axios from "axios";
const classNames = require('classnames');
import {useRouter} from "next/router";
import {useToasts} from "react-toast-notifications";
import Complement from './complement';
import Modal from 'react-modal';
import {forwardRef} from 'react';
import DatePicker, {registerLocale} from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { addDays } from 'date-fns';
import es from "date-fns/locale/es";
registerLocale("es", es);
import {BsCalendarDate} from 'react-icons/bs';
import configStatic from '../config-static.json';

const DetalleOptions = ({coverage, data, cart, delivery}) => {
    const router = useRouter();
    const { addToast } = useToasts();
    const [towns, setTowns] = useState([]);
    const [townSelected, setTownSelected] = useState(null);
    const [showTowns, setshowTowns] = useState(false);
    const [townSelectedData, setTownSelectedData] = useState(null);
    const [daySelected, setDaySelected] = useState(null);
    const [times, setTimes] = useState([]);
    const [dataDelivery, setDataDelivery] = useState({});
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [days, setDays] = useState([]);
    const [wasAdded, setwasAdded] = useState(false);
    const [dayActive, setdayActive] = useState(null);
    const [hourActive, sethourActive] = useState(null);
    const [modalVipIsOpen, setModalVipIsOpen] = React.useState(false);
    const [vipSelected, setVipSelected] = React.useState(null);
    const [startDate, setStartDate] = useState(new Date());
    const [calendarActive, setcalendarActive] = useState(false);
    const [excludeDate, setexcludeDate] = useState([]);

    useEffect(() => {
        if(daySelected){
            const t = moment(daySelected, 'DD/MM/YYYY').startOf("day").hour(12).unix();
            request(townSelected, t, d=>{
                setTimes(d.data.data.deliver);
                setDays(d.data);
            });
        }
    }, [daySelected]);

    useEffect(()=>{
        const {townid, date, hour, vip} = dataDelivery;
        if(townid && date && (hour || vip)){
            setIsButtonDisabled(false);
        }
    }, [dataDelivery]);

    useEffect(()=>{
        if(wasAdded){
            router.push('/compra');
        }
    }, [wasAdded])

    useEffect(() => {
        if(townSelected){
            request(townSelected, moment().unix(), (d)=>{
                setDays(d.data);
            });
        }
    }, [townSelected]);

    useEffect(()=>{
        if(delivery?.town?.town){
            setshowTowns(false);
            setTownSelectedData(delivery.town);
            setTownSelected(delivery.town.town.id);
        }
        let tmpDisableDate = [];
        if(data.available_feb14 === false || data.available_feb14 === 0){
            tmpDisableDate.push(new moment(configStatic.scheduleLabels.filter(i=>i.key==='available_feb14').shift().date).toDate())
        }
        if(data.available_may10 === false || data.available_may10 === 0){
            tmpDisableDate.push(new moment(configStatic.scheduleLabels.filter(i=>i.key==='available_may10').shift().date).toDate())
        }
        setexcludeDate(tmpDisableDate);

    }, [])

    const coverageItems = ()=>{
        return coverage.map((i,n)=>{
            return <li key={n} onClick={e=> setTowns({ data: i.municipios, state: { name: i.nombre, id: i.id_estado } })}>
                <span>{i.nombre}</span>
                <BsChevronRight/>
            </li>
        })
    };

    const request = (town, epochtime, next)=>{
        axios({
            url: `/api/time`,
            method: 'post',
            data: {
                town: townSelected,
                epochtime: epochtime
            }
        })
            .then(d=>{
                next(d)
            })
            .catch(e=>{
                next(e);
            })
    }

    const validateTowns = ()=>{
        if(towns.data?.length){
            let tmp = [<li className="dycDropdownBack" onClick={e=> setTowns([])} key={'RD0'}><BsChevronLeft/>Seleccionar otra ciudad</li>];
            towns.data.map(i=>{
                const d = { state: towns.state, town: {name: i.nombre, id:i.id_municipio} };
                tmp.push(<li onClick={e=>{setTownSelected(i.id_municipio); setTowns([]); setTownSelectedData(d);setshowTowns(false); }} key={i.id_municipio}>{i.nombre}</li>);
            });
            return tmp;
        }else{
            return coverageItems()
        }
    }

    const getDays = ()=>{
        if(days?.data?.inventory){
            return days.data.inventory.map(i=>{
                const sp = i.date.split('/');
                const f = configStatic.scheduleLabels.filter(k=> k.date ===  `${sp[2]}-${sp[1]}-${sp[0]}`)
                let dis = (f.length && (data[f[0].key] === 0 || data[f[0].key] === false))
                let v = classNames({ 'active': dayActive === i.date, 'disableDay': dis });
                let iconV = (i.day === '14'&& i.monthShort === 'feb') ? '♥️' : '';
                return <li
                    className={v}
                    onClick={e=> {
                        {{ (dis) ?
                            addToast('Este producto no está disponible para esta fecha, te invitamos a elegir otro', { appearance: 'warning', autoDismiss: true })
                            :
                            setDaySelected(i.date);
                            setdayActive(i.date);
                            setcalendarActive(false);
                        }}
                        }
                    }
                    key={i.date}><span>{i.nameShort}</span><small>{`${i.day} ${i.monthShort} ${iconV}`}</small>
                </li>
            })
        }else{
            return <p className="dycDetalleWarning dycDetalleWarning-info">Selecciona una ciudad para ver disponibilidad.</p>;
        }
    }

    const getTimes = ()=>{
        if(times && times.length){
            return times.map((i,n)=>{
                let v = classNames({ 'active': hourActive === i.label.label });
                return <li className={v} key={n} onClick={ e=>{ setDataDelivery({ townid: townSelected, date: daySelected, hour: i.label.label}); sethourActive(i.label.label); setVipSelected(null); } }><span>{i.label.label}</span><small>${i.price}</small></li>
            })
        }else if(daySelected){
            const str = (townSelectedData?.town?.name && days?.data?.date) ? (`No hay envios disponibles para ${townSelectedData.town.name} el día ${days.data.date}.`) : 'No hay envios disponibles para esta fecha.'
            return <p className="dycDetalleWarning">{str}<b>Selecciona un día diferente</b></p>;
        }else{
            return <p className="dycDetalleWarning dycDetalleWarning-info">Selecciona una fecha para tu envío.</p>;
        }
    }

    const getVip = ()=>{
        if(times?.length && days?.data?.vip.length) {
            return <li className={classNames('vip', {'active': vipSelected?.price})} onClick={()=>{ modalVIP() }}>Horario <b>VIP</b></li>
        }
    }

    const modalVIP = ()=>{
        setModalVipIsOpen(true);
    }
    const handleVIP = (hour)=>{
        setVipSelected(hour);
        setModalVipIsOpen(false);
        sethourActive(null);
        setDataDelivery({ townid: townSelected, date: daySelected, vip: hour});
    }

    const ModalVIP = ()=>{
        if(days?.data?.vip?.length) {
            return <Modal
                isOpen={modalVipIsOpen}
                className="dycModal"
                overlayClassName="dycModalOverlay"
                ariaHideApp={false}
            >
                <div className="dycModalHeader">
                    <h1 className="dycModalTitle">Elige un horario VIP</h1>
                    <span className="dycModalClose" onClick={closeModal}>
                    <GrClose/>
                </span>
                </div>
                <div className="dycModalBody">
                    <h2 className="dycModalDescription marginBottom">
                        Nuestros envios VIP reciben un tratamiento  prioritario y exclusivo. Asegura tu entrega en el
                        horario que lo necesites.
                        <br/><br/>
                        <b>Selecciona un horario:</b>
                    </h2>
                    <ul className="dycDetalleVip">
                        {days.data.vip.map((i, n) => {
                            return <li onClick={()=>{ handleVIP(i) }} key={n}><span className="dycDetalleVipLabel">{i.label}</span><small className="dycDetalleVipPrice">{i.price}</small></li>
                        })}
                    </ul>
                </div>
            </Modal>
        }
    }

    const closeModal = ()=>{
        setModalVipIsOpen(false);
    }

    const addCart = ()=>{
        const {date, hour, vip} = dataDelivery;
        axios({
            url: '/api/add-cart',
            method: 'POST',
            data: {
                town: townSelectedData,
                product: {
                    id: data.id_producto,
                    quantity: 1
                },
                delivery: { hour, date, vip }
            }
        }).then(d=>{
            setwasAdded(true);
        })
            .catch(e=>{
                addToast('No se puedo agregar el producto a tu carrito, recarga la pagina e intenta de nuevo', { appearance: 'warning', autoDismiss: false });
            })
    }
    const CustomInput = forwardRef(({ value, onClick }, ref) => (
        <button className={classNames('dycDetalleDatepicker', { active: calendarActive })} onClick={onClick} ref={ref}>
            <BsCalendarDate/>
            { (calendarActive) ? <>Fecha seleccionada: <span>{value}</span></> : 'Selecciona otra fecha'}
        </button>
    ));

    return <>
        <h4 className="dycDetalleStepsTitle">1-Selecciona la alcaldia o municipio de envio</h4>
        { ((townSelectedData && townSelectedData.state && townSelectedData.town) && !showTowns ) ? (
            <div className="dycDetalleTownselected" onClick={e=> setshowTowns(true) }>
                <span className="dycDetalleTownselectedCity">{ townSelectedData.town.name },{ townSelectedData.state.name }</span>
                <span className="dycDetalleTownselectedAction">Cambia de ciudad<CgArrowsExchangeV/></span>
            </div>
        ) : (
            <ul className="dycDropdown marginBottom">
                {validateTowns()}
            </ul>
        ) }
        <h5 className="dycDetalleStepsTitle">2-Selecciona una fecha de entrega</h5>
        <ul className="dycDetalleDays">
            {getDays()}
        </ul>
        {days?.data?.inventory &&
            <DatePicker
                dateFormat="dd/MM/yyyy"
                selected={startDate}
                locale={"es"}
                onChange={(date) => {
                    const DATE = moment(date).format('DD/MM/YYYY');
                    setStartDate(date);
                    setDaySelected(DATE);
                    setcalendarActive(true);
                    setdayActive(DATE);
                }}
                customInput={<CustomInput />}
                minDate={new Date()}
                maxDate={addDays(new Date(), 365)}
                excludeDates={excludeDate}
            />
        }
        <div className="marginBottom"></div>
        <h5 className="dycDetalleStepsTitle">3-Selecciona un horario de entrega</h5>
        {days?.data?.freeshipping>1 && (
            <div className="dycDetalleStepsWarning">
                <GrDeliver/>
                <span> Envios gratis a partir de ${days.data.freeshipping} <small>MXN</small> </span>
            </div>
        )}
        {/*{(days?.data?.date && townSelectedData?.town?.name) && <span className="dycDetalleDate">Horarios disponibles para {townSelectedData.town.name} el día {days.data.date}:</span> }*/}
        <ul className="dycDetalleDays dycDetalleDays-Hours marginBottom">
            {getVip()}
            {getTimes()}
        </ul>

        { ((townSelectedData && townSelectedData.state && townSelectedData.town) && !showTowns ) &&
        (<><h6 className="dycDetalleStepsTitle">4-Complementa tu compra</h6>
            <Complement /></>)
        }

        { (data?.price?.precio && !data?.disabled) ?
            (<button className="button button-large" disabled={isButtonDisabled} onClick={e=>{ addCart() }}>Agregar al carrito</button>)
            :
            (<button className="button button-large" disabled={true} >Producto no disponible o Agotado</button>)
        }
        {ModalVIP()}
    </>
};

export default DetalleOptions;
